import React from 'react';
import { Link } from "react-router-dom";
import { authHeaders } from "../servicios/auth";

class Multas extends React.Component {

    render() {

         const usuario = JSON.parse(localStorage.getItem("usuario"));
        const rol = Number(usuario?.rol);
        return (
            <div className="container mt-4">

                <div className="card shadow">

                    <div className="card-header bg-dark text-white">
                        <h4>MÓDULO DE MULTAS</h4>
                    </div>

                    <div className="card-body">

                        <div className="row">
                        {(Number(usuario?.rol) === 1 || Number(usuario?.rol) === 3) && (
                            <div className="col-md-4 mb-3">
                                <Link
                                    to="/crearmultas"
                                    className="btn btn-success w-100 p-4"
                                >
                                    <i className="bi bi-receipt-cutoff me-2"></i>
                                    + NUEVA MULTA
                                </Link>
                            </div>
                            )}
                            <div className="col-md-4 mb-3">
                                <Link
                                    to="/listarmultas"
                                    className="btn btn-primary w-100 p-4"
                                >
                                    <i className="bi bi-search me-2"></i>
                                    CONSULTAR MULTAS
                                </Link>
                            </div>

                    {(Number(usuario?.rol) === 1 || Number(usuario?.rol) === 2) && (
                            <div className="col-md-4 mb-3">
    <Link
        to="/reportesmultas"
        className="btn btn-danger w-100 p-4"
    >
        <i className="bi bi-file-earmark-pdf me-2"></i>
        REPORTES
    </Link>
</div>
)}
                        </div>

                    </div>

                </div>

            </div>
        )
    }
}

export default Multas;